import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../index'

const initialState = {
  isCheckingEligibility: false,
}

const eligibilitySlice = createSlice({
  name: 'eligibility',
  initialState,
  reducers: {
    setIsCheckingEligibility(state, action) {
      state.isCheckingEligibility = action.payload
    },
  },
})

export const { setIsCheckingEligibility } = eligibilitySlice.actions
export default eligibilitySlice.reducer
export const getEligibilityState = (state: RootState) => state.eligibility
